import { CalendarIcon } from '@panwds/icons';
import { DatePickerDialog } from '@panwds/react-ui';
import { classNames } from '@panwds/tailwindcss';
import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useFilters } from '../../../hooks/index.js';
import { PillValue } from '../../Pill/PillValue.js';
/**
 * Provides a filter with a custom option that allows selecting a time range.
 *
 * Pass items via context in your filter config to provide extra options in the dropdown.
 * All extra props passed via context will be passed to the DateRangePicker2.
 */
export const DatePickerDialogFilter = ({ name, id = 'date-filter', className, required, autoFocus, disabled, label, onClose, getCustomLabel, ...rest }) => {
    const { filters, setFilters } = useFilters();
    const selectedDateString = filters[name];
    const [customLabel, setCustomLabel] = useState(undefined);
    useEffect(() => {
        if (selectedDateString) {
            const selectedDate = new Date(selectedDateString);
            const generatedLabel = getCustomLabel?.(selectedDate) || `${format(selectedDate, rest.dateFormat || 'PP')}`;
            setCustomLabel(generatedLabel);
        }
        else {
            setCustomLabel(undefined);
        }
    }, [filters[name], getCustomLabel, rest.dateFormat]);
    return (React.createElement(DatePickerDialog, { ...rest, className: typeof className === 'object' ? className?.datePickerDialog : className, label: "", selectedDate: selectedDateString ? new Date(selectedDateString) : undefined, onApply: (selectedDate) => {
            setFilters({
                [name]: selectedDate.toISOString()
            });
        }, button: React.createElement(PillValue, { autoFocus: autoFocus, labelKey: typeof label === 'string' ? label : '', labelValue: customLabel, disabled: disabled, addClassName: classNames('group', typeof className === 'object' ? className?.button : ''), displayAsString: true, onClose: onClose, required: required, leftIcon: React.createElement(CalendarIcon, { size: "sm" }) }) }));
};
//# sourceMappingURL=date_picker_dialog_filter.js.map